import React from 'react';
import { useIntl } from 'react-intl';
import { useModeContext } from '../../../common/contexts/mode-context';
import { MODE } from '../../../constants';
import DisabledFormEmptyState from './DisabledFormEmptyState';
import messages from './messages';
import css from './disabled-form-page.module.scss';

const DisabledFormPage = () => {
  const { mode } = useModeContext();
  const intl = useIntl();

  const message = intl.formatMessage(
    mode === MODE.FORM
      ? messages.disabledFormMessage
      : messages.disabledFileRequestMessage,
  );

  return (
    <div className={css.container}>
      <DisabledFormEmptyState formType={mode} message={message} />
    </div>
  );
};

export { DisabledFormPage };
export default DisabledFormPage;
